<div class="c-navigation-menu__list">
    <div *ngFor="let menuItem of items; let index = index">
        <div class="c-navigation-menu__item"
            payStateRef
            activeClass="is-active"
            [matchType]="STATE_STARTS_WITH"
            [excludePath]="menuItem.exceptions"
            [state]="menuItem.state"
            (click)="clickMenuItem(menuItem, index, $event)">

            <pay-icon *ngIf="menuItem.icon" 
                [name]="menuItem.icon"
                class="x-menu-item-icon"></pay-icon>
            {{ menuItem.label | translate }}

            <pay-icon *ngIf="menuItem?.items?.length"
                [name]="accordionStatus[index] ? 'alt-arrow-up' : 'alt-arrow-down'"
                class="x-menu-dropdown-icon c-icon--xs"></pay-icon>
        </div>

        <div *ngIf="accordionStatus[index]" class="c-navigation-menu__sub-list">
            <div *ngFor="let subMenuItem of menuItem.items"
                (click)="goTo(subMenuItem.state)"
                class="c-navigation-menu__sub-item"
                payStateRef
                activeClass="is-active"
                [matchType]="STATE_STARTS_WITH"
                [state]="subMenuItem.state">
                {{ subMenuItem.label | translate }}
            </div>
        </div>
    </div>
</div>
